import {
  Outlet,
  NavLink,
} from "react-router-dom";
import { useEffect, useState } from 'react'
import Login from './login'
import { saveToLS, getFromLS } from "../utils/localstorage";

export async function loader() {
  return null;
}

export async function action() {
  return null;
}

export default function Root() {
  // Toggle sidebar collapse state (by changing the css class)
  const [sidebarStyle, setSidebarStyle] = useState("sidebar");
  const [sidebarHamburgerStyle, setSidebarHamburgerStyle] = useState("hamburger");
  const [authorized, setAuthorized] = useState(false);

  const updateSidebar = () => {
    if (sidebarStyle === "sidebar")
    {
      setSidebarStyle("sidebar collapsed");
      setSidebarHamburgerStyle("hamburger cHamburger");
    }
    else
    {
      setSidebarStyle("sidebar");
      setSidebarHamburgerStyle("hamburger");
    }
  }

  useEffect(() => {
    // Send a request to check if the user has a valid session token
    // If so, display restricted information.
    // (This is purely a UI thing, real restricted information should be handled by api requests)
    let sessiontoken = getFromLS('sessiontoken');
    if (sessiontoken) {
      console.log("token in storage == " + sessiontoken);

      const headers = {
        'sessiontoken': sessiontoken,
      };

      const fetchData = async () => {
        try {
          const res = await fetch(
            '/api/checkAccess',
            {
              method: "get",
              headers: headers,
            }
          );
          let response = await res.json();
          setAuthorized(response.access);
        } catch (e) { };
      }

      fetchData();
    }
    // TODO: this is another place that needs api location updates 
  }, []);

  return (
    <div className='outer'>
      <Outlet />
      <img className={sidebarHamburgerStyle} alt="" onClick={updateSidebar}></img>
      <div className={sidebarStyle}>
        <h1><NavLink to="/">Nate's Bin</NavLink></h1>
        <nav>
          <NavLink to="/resume">Resume</NavLink>
          <NavLink to="https://www.linkedin.com/in/nathan-beals-10672654/" target="_blank" rel="noopener noreferrer">Linkedin</NavLink>
          <NavLink to="https://github.com/NathanBeals" target="_blank" rel="noopener noreferrer">Github</NavLink>
          <NavLink to="/help">Help</NavLink>
          {authorized ? <NavLink to="/restricted/test">Restricted</NavLink> : <div></div>}
          {authorized ? <NavLink to="/flashcards">Flash Cards</NavLink> : <div></div>}
        </nav>
        <div className="commonTagsHeader">Common Tags
          <NavLink className="commonTags" to="/?tags=top10">Top 10</NavLink>
          <NavLink className="commonTags" to="/?tags=recent">Recent</NavLink>
          <NavLink className="commonTags" to="/?tags=pi">Pi</NavLink>
          <NavLink className="commonTags" to="/?tags=web">Web</NavLink>
          <NavLink className="commonTags" to="/?tags=unity">Unity</NavLink>
          <NavLink className="commonTags" to="/?tags=unreal">Unreal</NavLink>
          <NavLink className="commonTags" to="/?tags=cooking">Cooking</NavLink>
        </div>
        <div className="login"><Login/></div>
        <h2>Powered by Pi</h2>
      </div>
    </div>
  );
}